// Purpose: Build canonical entry detail URLs and resolve stored slugs or legacy document IDs.
// Features: Stable entrySlug links with backwards-compatible ID lookup.
// Dependencies: Firebase Firestore client SDK; slug allocation belongs to server entry_slugs.js.
// Important behavior: Detail URL identifiers never replace entry IDs used by votes, QR ballots, or management.

import { collection, doc, getDoc, getDocs, limit, query, where } from "firebase/firestore";

export const getEntryPath = (eventslug, entry) => `/${eventslug}/entries/${encodeURIComponent(entry?.entrySlug || entry?.id || "")}`;
export const getEntryEditPath = (eventslug, entry) => `/${eventslug}/entry_reg/${encodeURIComponent(entry?.entrySlug || entry?.id || "")}`;
export const isValidEntrySlug = (value) => typeof value === "string" && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value) && value.length <= 100;

export const resolveEntrySnapshot = async (db, eventId, identifier) => {
  const legacy = await getDoc(doc(db, "events", eventId, "cars", identifier));
  if (legacy.exists()) return legacy;
  const matches = await getDocs(query(collection(db, "events", eventId, "cars"), where("entrySlug", "==", identifier), limit(1)));
  if (matches.docs[0]) return matches.docs[0];
  if (!isValidEntrySlug(identifier)) return null;
  const alias = await getDoc(doc(db, "events", eventId, "entry_slug_claims", identifier));
  if (!alias.exists()) return null;
  const entryId = alias.data().entryId;
  if (typeof entryId !== "string" || !entryId || entryId.includes("/")) return null;
  const current = await getDoc(doc(db, "events", eventId, "cars", entryId));
  return current.exists() ? current : null;
};
